
import { Component, Vue } from 'nuxt-property-decorator'

@Component
export default class IconFilter2 extends Vue {
}
